"use client"

import type { LocationChangeArgs } from "@/modules/jobAds/client/components/AlgoliaLocationFilter/LocationFilter/LocationFilter"

import { clsx } from "clsx"
import { type FunctionComponent, useState } from "react"

import { LocationFilter } from "@/modules/jobAds/client/components/AlgoliaLocationFilter/LocationFilter/LocationFilter"
import { RadiusFilter } from "@/modules/jobAds/client/components/AlgoliaLocationFilter/RadiusFilter/RadiusFilter"
import { useJobAdsSearchParams } from "@/modules/jobAds/client/hooks/useJobAdsSearchParams"
import { computeLocationObjectFromSingleQueryParam } from "@/modules/locations/locations"

import styles from "./AlgoliaLocationFilter.module.css"

type AlgoliaLocationFilterProps = {
  abroadOnlyLabel: string
  className?: string
  clearLabel: string
  enableAbroadOption: boolean
  placeholder: string
  radiusLabel: string
}

export const AlgoliaLocationFilter: FunctionComponent<AlgoliaLocationFilterProps> = ({
  abroadOnlyLabel,
  className,
  clearLabel,
  enableAbroadOption,
  placeholder,
  radiusLabel,
}) => {
  const searchParams = useJobAdsSearchParams()
  const location = searchParams.get("location") || undefined
  const locationQueryParam = Array.isArray(location) ? location[0] : location
  const locationObject = locationQueryParam && computeLocationObjectFromSingleQueryParam(locationQueryParam)

  const [isLocationACity, setIsLocationACity] = useState(!!locationObject?.city)

  const isRadiusEnabled = isLocationACity

  const onLocationChange = (args: LocationChangeArgs): void => {
    setIsLocationACity(args.isLocationACity)
  }

  return (
    <div className={clsx(styles.main, className)}>
      <LocationFilter
        abroadOnlyLabel={abroadOnlyLabel}
        clearLabel={clearLabel}
        enableAbroadOption={enableAbroadOption}
        onLocationChange={onLocationChange}
        placeholder={placeholder}
      />
      {isRadiusEnabled && <RadiusFilter label={radiusLabel} />}
    </div>
  )
}
